/**
 *
 * The DismissableBanner duck. Default export is the reducer, per duck law.
 *
 * Action Types:
 *
 * DISMISS_BANNER
 *
 * Action Creators:
 *
 * dismissBanner();
 */

import type {
  DismissableBannerState,
  DismissBannerAction,
  DismissableBannerAction,
} from '../types';

import get from 'lodash/get';

/** @type {ActionType} **/
/** The dismiss banner action. **/
export const DISMISS_BANNER = 'PB/dismissableBanner/DISMISS_BANNER';

/** @ignore
 * We start with an array of the list of hidden banners; nothing is hidden at start.
 */
export const initialState = {
  hiddenBanners: [],
};

/** @ignore **/
export default function dismissableBanner(
  state: DismissableBannerState = initialState,
  action: DismissableBannerAction,
): DismissableBannerState {
  switch (action.type) {
    case DISMISS_BANNER:
      const hiddenBanners = get(state, 'hiddenBanners', []);
      const bannerId = get(action, 'payload.bannerId', '');

      if (!hiddenBanners.includes(bannerId)) {
        hiddenBanners.push(bannerId);
      }

      return { hiddenBanners };

    default:
      return state;
  }
}

/**
 * This action creator will return a DISMISS_BANNER action
 * with the id of the banner to be hidden.
 *
 * @type {ActionCreator}
 *
 * @param {number} bannerId The id of the banner to hide.
 * @return {DismissBannerAction}
 * @property {ActionType} type DISMISS_BANNER
 * @property {Object} payload The payload parameter.
 * @property {number} bannerId The id of the banner to hide.
 */

export function dismissBanner(bannerId: string): DismissBannerAction {
  return {
    type: DISMISS_BANNER,
    payload: { bannerId },
  };
}
